import modalTemplateURL from 'ngtemplate-loader!./paymentModal.tpl.html';

const name = 'giftPaymentModal'

export const template = modalTemplateURL;
export default class PaymentModal {

  constructor($modalInstance, gift, formClass) {
    angular.extend(this, $modalInstance);
    this.gift = angular.extend({}, gift);
    this.form = formClass;
    this._tab = 'discount';
    this._errors = [];
  }

  activeTab(tab) {
    return this._tab === tab;
  }

  $onInit() {}

  done() {

    if (this.activeTab('discount')) {
      const matched = this.gift.discount.match(/^(\$)?(\d+)(\%)?$/);
      if (!matched) {
        this.FORM['giftDiscount'].$setValidity('format', false);
      } else {
        this.FORM['giftDiscount'].$setValidity('format', true);
      }
    }

    if (this.FORM.$valid) this.close({ 'active': this._tab, gift: this.gift });

  };

  cancel() {
    this.dismiss({ $value: 'cancel' });
  };


}


// WEBPACK FOOTER //
// ./client/assets/scripts/modules/gifts/paymentModal.js